/** 布局与顶栏（中文，与当前产品一致） */
export default {
  layout: {
    manager: '管理方',
    managerNotSelected: '未选择管理方',
    switchingToManager: '正在切换到{name}…',
    switchedToManager: '已切换到{name}',
    selectManagerTitle: '选择管理方',
    managerSearchPlaceholder: '搜索名称或地址',
    managerSearchEmpty: '未找到匹配的管理方',
    defaultBadge: '默认',
    currentBadge: '当前',
    switchTo: '切换至',
    setAsDefault: '设为默认',
    setDefaultManagerConfirm: '确认将「{name}」设为默认管理方？',
    setDefaultManagerHint: '提示',
    setDefaultManagerSuccess: '默认管理方设置成功',
    currentPlatform: '当前平台',
    enterFullscreen: '进入全屏',
    exitFullscreen: '退出全屏',
    settings: '个性设置',
    profile: '个人中心',
    changePassword: '修改密码',
    logout: '退出登录',
    energyScreen: '能源大屏',
    manual: '操作手册',
    langZh: '中文',
    langEn: 'English',
    langShortZh: 'CN',
    langShortEn: 'EN',
    defaultUser: '管理员',
    langSwitchTitle: '单击切换界面语言'
  },
  tagsView: {
    more: '更多',
    tagManage: '标签管理',
    tagCount: '共 {n} 个标签',
    searchPlaceholder: '搜索标签名称…',
    visibleNow: '当前显示',
    moreTags: '更多标签',
    refreshTip: '刷新当前页',
    closeOthersTip: '关闭其他'
  }
}
